export default __webpack_public_path__ + "static/media/pricing.ff06c1cc.svg";